import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1073b0df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-wrapper" }
const _hoisted_2 = { class: "input-field" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["type", "name", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.name
          }, _toDisplayString(_ctx.label), 9, _hoisted_3))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", _mergeProps({
        type: _ctx.type,
        name: _ctx.name,
        class: { 'error': _ctx.hasError, disabled: _ctx.disabled, 'valid': _ctx.valid, 'active': _ctx.active },
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
      }, _ctx.$attrs, {
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
      }), null, 16, _hoisted_4), [
        [_vModelDynamic, _ctx.inputValue]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "input-field__error",
          key: index
        }, _toDisplayString(error.$message), 1))
      }), 128)),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}